import { Component, OnInit } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UserComplete, UserStatus, UserType } from '../../interfaces/user.interfaces';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [TranslateModule, CommonModule, FormsModule],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css'
})
export class ProfileComponent implements OnInit {
  userProfile: UserComplete | null = null;
  editableProfile: UserComplete | null = null;
  isEditing = false;
  isSaving = false;
  saveSuccess = false;
  saveError = false;
  
  // Opzioni per i select
  availableLanguages = ['it', 'en', 'fr', 'de', 'es'];
  availableStatuses = Object.values(UserStatus);
  availableUserTypes = ['USER', 'ADMIN', 'MANAGER', 'SUPPORT'];
  availableAffiliationTypes = ['COMPANY', 'PERSONAL', 'PARTNER', 'VENDOR'];
  
  constructor(
    private translateService: TranslateService,
    private dataService: DataService
  ) {}

  ngOnInit(): void {
    // Carica i dati dell'utente (in un caso reale questi dati verrebbero
    // da un API, qui simulo con dati statici per dimostrazione)
    this.loadUserProfile();
  }
  loadUserProfile(): void {
    // In un'app reale, qui chiameresti un servizio per ottenere i dati dall'API
    // Esempio: this.userService.getUserProfile().subscribe(data => this.userProfile = data);
    
    // Recupera i dati utente dal DataService
    const users = this.dataService.getData<UserComplete[]>('users');
    if (users && users.length > 0) {
      // Prendiamo il primo utente disponibile per la dimostrazione
      this.userProfile = users[0];
    } else {
      console.warn('Nessun dato utente trovato nel DataService');
      this.userProfile = null;
    }
  }

  getFormattedDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString(this.translateService.currentLang);
  }

  toggleEditMode(): void {
    if (!this.isEditing) {
      // Entrando in modalità modifica: crea una copia dei dati per l'editing
      this.editableProfile = this.userProfile ? JSON.parse(JSON.stringify(this.userProfile)) : null;
    } else {
      // Uscendo dalla modalità modifica senza salvare: cancella le modifiche
      this.editableProfile = null;
      this.resetMessages();
    }
    this.isEditing = !this.isEditing;
  }
  
  saveChanges(): void {
    if (!this.editableProfile) return;
    
    this.isSaving = true;
    this.resetMessages();
    
    // Simula una chiamata API asincrona
    setTimeout(() => {
      try {
        // In un'app reale, qui chiameresti il servizio per salvare i dati
        // Esempio: this.userService.updateUserProfile(this.editableProfile).subscribe(...)
          // Per ora, aggiorniamo direttamente l'oggetto userProfile
        if (this.editableProfile) {
          this.userProfile = { ...this.editableProfile as UserComplete };
        }
        
        this.saveSuccess = true;
        this.isSaving = false;
        
        // Esci dalla modalità modifica dopo il salvataggio
        setTimeout(() => {
          this.isEditing = false;
          this.resetMessages();
        }, 2000);
      } catch (error) {
        console.error('Errore durante il salvataggio del profilo', error);
        this.saveError = true;
        this.isSaving = false;
      }
    }, 1000); // Simula un ritardo di rete di 1 secondo
  }
  
  resetMessages(): void {
    this.saveSuccess = false;
    this.saveError = false;
  }
  
  // Getter per accedere facilmente al profilo in modifica o visualizzazione
  get currentProfile(): UserComplete | null {
    return this.isEditing ? this.editableProfile : this.userProfile;
  }
}
